import { Button, Text } from '@chakra-ui/react';
import Balance from '@ui/components/Balance';
import { Card } from '@ui/components/Card';
import {
  ModalOrDrawerBody,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import usePendingVno from '@ui/hooks/usePendingVno';
import { useTranslations } from '@ui/i18n';
import { gardenTokenDict } from '@ui/utils/garden';

import { GardenVaultSelection } from '../GardenVaultSelection';
import { GardenVnoAllocationInfo } from '../GardenVnoAllocationInfo';
import { useGardenPlantDrawer } from './useGardenPlantDrawer';
import { useGardenPlant } from './utils';

export const DefaultContent = () => {
  const t = useTranslations();
  const coinMode = useGardenPlantDrawer((s) => s.coinMode);
  const isWithdraw = useGardenPlantDrawer((s) => s.isWithdraw);
  const onClose = useGardenPlantDrawer((s) => s.onClose);
  const vaultType = useGardenPlantDrawer((s) => s.vaultType);
  const setVaultType = useGardenPlantDrawer((s) => s.setVaultType);
  const tLcroPlantAmount = useGardenPlantDrawer((s) => s.tLcroPlantAmount);
  const gardenType = useGardenPlantDrawer((s) => s.gardenType);

  const { pendingVno } = usePendingVno(gardenType);
  const { mutate: doPlant } = useGardenPlant();

  return (
    <>
      <ModalOrDrawerBody alignItems="center">
        <Balance
          title={
            isWithdraw
              ? t('Amount of {coin} to withdraw', {
                  coin: gardenTokenDict[coinMode][gardenType].name,
                })
              : t('Amount of {coin} to plant', {
                  coin: gardenTokenDict[coinMode][gardenType].name,
                })
          }
          amount={tLcroPlantAmount}
          unitDecimals={gardenTokenDict[coinMode][gardenType].decimals}
        />
        <Text mt="22px">
          {isWithdraw
            ? t('On withdraw, you will harvest your pending yield')
            : t('On deposit, you will harvest your pending yield')}
        </Text>
        <Card shadow="card.active" p="16px 16px 20px" m="0" mt="16px">
          <GardenVnoAllocationInfo
            vnoAmountTitle={t('Pending rewards')}
            vnoAmount={pendingVno}
            allocationTitle={t('{coin} distribution', {
              coin: 'VNO',
            })}
            intoWalletTitle={t('Receive in wallet')}
            into12MonthTitle={t('Lock for 12 months')}
          />
        </Card>
        <Text mt="24px">{t('Where do you want to lock your VNO?')}</Text>
        <GardenVaultSelection
          className="veno-tour__plant-modal-vault-selection"
          mt="4px"
          vaultType={vaultType}
          onChange={(vaultType) => setVaultType(vaultType)}
        />
      </ModalOrDrawerBody>
      <ModalOrDrawerFooter>
        <Button
          className="veno-tour__plant-modal-confirm-button"
          disabled={!vaultType}
          onClick={() => {
            doPlant();
          }}
        >
          {t('Confirm')}
        </Button>
        <Button mt={2.5} variant="link" onClick={onClose}>
          {t('Cancel')}
        </Button>
      </ModalOrDrawerFooter>
    </>
  );
};
